// extracted by mini-css-extract-plugin
export default {"headerBar":"rL-z","pointsSection":"sL-z","goToDashboard":"tL-z"};